<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>MerchantApp Welcome Ekranı Banner Ekle</h4>
      <v-row style="margin-top: 50px;">
        <v-col cols="12" md="4">
          <h4>Başlık</h4>
          <v-text-field
            v-model="onBoardingData.title"
            maxlength="255"
            counter="255"
            :rules="titleRules"
            required
            name="input-7-1"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8">
          <h4>Açıklama</h4>
          <v-textarea
            v-model="onBoardingData.description"
            maxlength="255"
            counter="255"
            rows="1"
            auto-grow
            :rules="descriptionRules"
            required
            name="input-7-1"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <h4>
            Link
            <v-icon
              style="font-size: 17px;"
              v-if="!infoLink"
              color="#4d48f9"
              @click="infoLink = true"
            >
              info
            </v-icon>
          </h4>
          <v-alert
            v-model="infoLink"
            border="left"
            close-text="Close Alert"
            color="#4d48f9"
            dark
            dismissible
          >
            Dış Link eklerken http, https protokollerinin girilmesi gereklidir.
            <br />
            Örneğin: http://frink.com.tr, https://frink.com.tr
          </v-alert>
          <v-text-field
            v-model="onBoardingData.link"
            maxlength="255"
            counter="255"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <h4>Link Metni</h4>
          <v-text-field
            v-model="onBoardingData.linkText"
            required
          ></v-text-field>
        </v-col>
      </v-row>

      <v-col cols="12" md="4">
        <h4>Sıralama</h4>
        <v-text-field
          v-model="onBoardingData.ordering"
          type="number"
          min="0"
          :rules="orderRules"
          required
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="4">
        <h4>
          Görsel
          <v-icon
            style="font-size: 17px;"
            v-if="!infoImage"
            color="#4d48f9"
            @click="infoImage = true"
          >
            info
          </v-icon>
        </h4>
        <v-alert
          v-model="infoImage"
          border="left"
          close-text="Close Alert"
          color="#4d48f9"
          dark
          dismissible
        >
          Görsel boyutu: 654x400
          <br />
          Format: JPG
          <br />
          Dosya boyutu: Maximum 350 KB
        </v-alert>
        <v-img
          style="cursor: pointer;"
          v-if="imgUrl != '' && imgUrl != undefined"
          :src="imgUrl"
          aspect-ratio="1.7"
        ></v-img>
        <!-- <v-text-field v-model="onBoardingData.imgUrl" :rules="imgUrlRules" required></v-text-field> -->
        <v-file-input
          show-size
          accept="image/*"
          v-model="onBoardingData.img"
          @change="previewFiles"
          label="Resim yükle"
          :rules="imageRules"
          required
        ></v-file-input>
      </v-col>
      <v-col cols="12" md="3">
        <h4>Aktif/Pasif</h4>
        <v-checkbox
          v-model="onBoardingData.active"
          color="#4d48f9"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="7">
        <v-btn
          depressed
          color="#4d48f9"
          style="text-transform: none !important; float: right; color: white;"
          @click="onBoardingAdd()"
        >
          EKLE
        </v-btn>
      </v-col>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="fruit in this.errorList" :key="fruit">{{ fruit }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- <v-row>
            
        </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'MerchantOnBoarding',
  methods: {
    ...mapActions(['addMerchantOnBoarding']),
    routeUsers() {
      this.$router.push('/dashboard/merchant-onboardings')
    },
    onBoardingAdd() {
      if (this.$refs.form.validate()) {
        this.snackbar = true

        if (
          this.onBoardingData.img == null ||
          this.onBoardingData.img == undefined
        ) {
          alert('Resim alanı dolu olmalıdır')
          return
        }

        this.addMerchantOnBoarding(this.onBoardingData)
          .then((response) => {
            if (response.payload) {
              this.$router.push('/dashboard/merchant-onboardings')
            }
          })
          .catch((err) => {
            alert(err)
          })
      } else {
        var errors = []
        var x = document.getElementsByClassName('v-messages__message')
        for (var i = 0; i < x.length; i++) errors.push(x[i].innerHTML)

        this.errorList = errors

        this.dialog = true
      }
    },
    previewFiles() {
      console.log('img', this.imgUrl)
      if (this.onBoardingData.img == undefined) {
        this.imgUrl = ''
      } else {
        const file = this.onBoardingData.img
        this.imgUrl = URL.createObjectURL(file)
      }
    },
  },
  data: () => ({
    alert: false,
    onBoardingData: {
      img: null,
      title: '',
      description: '',
      link: '',
      linkText: '',
      ordering: 0,
      active: false
    },
    valid: true,
    imgUrl: '',
    imageRules: [
      (v) => !!v || 'Resim alanı zorunludur.',
      (v) =>
        (v && v.size <= 350 * 1024) ||
        'Dosya boyutu en fazla 350 KB olmalıdır.',
    ],
    titleRules: [
      (v) => !!v || 'Başlık alanı zorunludur.',
      (v) => v.trim().length > 0 || 'Başlık alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    descriptionRules: [
      (v) => !!v || 'Açıklama alanı zorunludur.',
      (v) => v.trim().length > 0 || 'Açıklama alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    orderRules: [
      (v) => parseFloat(v) > -1 || "Sıralama 0'dan küçük olmamalıdır.",
    ],
    fileRules: [
      // value => value.size < 1000 || 'Avatar size should be less than 2 MB!',
      (v) => !!v || 'Resim gereklidir.',
      (v) => (v && v.name != null) || 'Resim gereklidir.',
    ],
    errorList: [],
    dialog: false,
    infoImage: false,
    infoLink: false,
  }),
}
</script>
